import React, { useState } from 'react';
import Button from './Button';
import Input from './Input';
import Main from './Main';

interface Props {
  onSignInWithEmail: (username: string, password: string) => void,
  onSignInWithGoogle: () => void
}

function PureLogin(props: Props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const handleSignInWithEmail = () => {
    props.onSignInWithEmail(username, password);
  }

  return <Main>
    <div className="bg-white rounded-lg p-6 max-w-sm m-auto grid grid-cols-1 gap-1 shadow-md text-center">
      <h1 className="text-lg font-bold mb-2">Please sign in</h1>
      <Button color="secondary" onClick={props.onSignInWithGoogle}>Sign in with Google</Button>
      <p>OR</p>
      <Input value={username} onChange={setUsername} placeholder="Email" />
      <Input type="password" value={password} onChange={setPassword} placeholder="Password" />
      <Button color="primary" onClick={handleSignInWithEmail}>Sign in with email</Button>
    </div>
  </Main>
}

export default PureLogin;
